import { Box, CircularProgress } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { skuResultsStyles as s } from '../Styles/StockBySkuResults.styles'

export type PositionFilter = 'sale' | 'all'

export const POSITION_OPTIONS: { key: PositionFilter; label: string }[] = [
  { key: 'sale', label: 'Solo de venta' },
  { key: 'all', label: 'Todas' }
]

export const PositionFilterToggle: React.FC<{
  value: PositionFilter
  onChange: (filter: PositionFilter) => void
  disabled?: boolean
}> = ({ value, onChange, disabled }) => {
  const groupRef = useRef<HTMLDivElement | null>(null)
  const btnRefs = useRef<(HTMLButtonElement | null)[]>([])
  const [sliderStyle, setSliderStyle] = useState({ left: 0, width: 0 })

  const updateSlider = useCallback(() => {
    const group = groupRef.current
    const activeIdx = POSITION_OPTIONS.findIndex((o) => o.key === value)
    const btn = btnRefs.current[activeIdx]
    if (!group || !btn) return
    const gRect = group.getBoundingClientRect()
    const bRect = btn.getBoundingClientRect()
    setSliderStyle({ left: bRect.left - gRect.left, width: bRect.width })
  }, [value])

  useEffect(() => {
    updateSlider()
    window.addEventListener('resize', updateSlider)
    return () => window.removeEventListener('resize', updateSlider)
  }, [updateSlider])

  return (
    <Box ref={groupRef} sx={s.toggleGroup}>
      <Box sx={s.toggleSlider(sliderStyle.left, sliderStyle.width)} />
      {POSITION_OPTIONS.map((opt, i) => {
        const isActive = value === opt.key
        return (
          <Box
            key={opt.key}
            component='button'
            ref={(el: HTMLButtonElement | null) => {
              btnRefs.current[i] = el
            }}
            onClick={() => onChange(opt.key)}
            disabled={disabled}
            sx={s.toggleBtn(isActive)}
          >
            {isActive && disabled ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1
                }}
              >
                <CircularProgress size={13} sx={{ color: 'inherit' }} />
                {opt.label}
              </Box>
            ) : (
              opt.label
            )}
          </Box>
        )
      })}
    </Box>
  )
}
